import styled from 'styled-components';

export const BaseLabel = styled.p`
  font-weight: bold;
  margin-bottom: 15px;
`;

export const Label = styled(BaseLabel)`
  font-size: 18px;
`;

export const ListLabel = styled(BaseLabel)`
  font-size: 16px;
`;

export const Flex = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FlexDisplay = styled(Flex)`
  display: flex;
  flex-direction: column;
`;

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: ${(props) => `repeat(${props.columns}, 1fr)`};
  margin-bottom: 20px;
  gap: 20px;
`;
